require('./aggregatorFundDetails.scss');

import React from 'react';
import PropTypes from 'prop-types';

// @components
import { AggregatorTableDetails } from 'components/aggregator/aggregatorDetails/aggregatorTableDetails/aggregatorTableDetails';

// @helpers
import { getLastNChars } from 'utilities/stringHelper';

// @constants
const TRANSLATION_KEY_PREFIX = "AggregatorFundsDetails";

const { FormattedText } = require('core/i18n').i18n;

class AggregatorFundDetails extends React.PureComponent {

    buildName = (item) => {
        const fundName = item.get('alias');
        const accountNumber = getLastNChars(item.get('account', '').toString());

        return (
            <div className="aggregator-fund-details__name">
                <div className="aggregator-fund-details__name__title">
                    {fundName}
                </div>
                <div className="aggregator-fund-details__name__account">
                    <FormattedText value={`${TRANSLATION_KEY_PREFIX}-account`}/>
                    <span className="aggregator-fund-details__name__account__number">
                        {accountNumber}
                    </span>
                </div>
            </div>
        );
    };

    buildItem = (item) => {
        const quantity = item.get('quantity');
        const valueDate = item.get('valueDate');
        const rent = item.get('rent', null) && `${item.get('rent')}%`;
        const balance = item.get('balance');

        return [{
            type: 'custom',
            value: this.buildName(item),
        },{
            type: 'number',
            value: quantity,
        },{
            type: 'date',
            value: valueDate,
        },{
            type: 'text',
            value: rent,
            bold: true,
        },{
            type: 'amount',
            value: balance,
            bold: true,
        }];
    };

    buildTableValues = () => {
        const { products } = this.props;

        return products.map(item => this.buildItem(item));
    };

    buildTableHeader = () => {
        return [
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-name`} value={`${TRANSLATION_KEY_PREFIX}-name`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-participations`} value={`${TRANSLATION_KEY_PREFIX}-participations`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-valorationDate`} value={`${TRANSLATION_KEY_PREFIX}-valorationDate`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-rent`} value={`${TRANSLATION_KEY_PREFIX}-rent`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-value`} value={`${TRANSLATION_KEY_PREFIX}-value`}/>
        ];
    };

    render() {
        const header = this.buildTableHeader();
        const values = this.buildTableValues();

        return (
            <AggregatorTableDetails
                investmentTable={true}
                values={values}
                header={header}
            />
        );
    }
}

AggregatorFundDetails.propTypes = {
	products: PropTypes.object,
};

export { AggregatorFundDetails };
